import React, { useState } from 'react';
import { Modal, Button, Container } from 'react-bootstrap';
import { formatCurrency } from '../../utils/appUtils';

const WishlistModal = ({ data }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);

  const openViewModal = (data) => {
    setModalData(data);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalData(null);
  };

  return (
    <>
      <Button className="btn sis-button" variant="none" onClick={() => openViewModal(data)}>
        View Items
      </Button>

      <Modal show={showModal} onHide={closeModal} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Product Information</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          {modalData ? (
            <>
              <h5 className="mb-3">Items</h5>
              <div className="table-responsive">
                <table className="table table-striped table-bordered">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Product SKU</th>
                      <th>Product Title</th>
                      <th>Sale Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {modalData.items.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.product_sku}</td>
                        <td>{item.product_title}</td>
                        <td>{formatCurrency(item.price)}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="3" className="text-end"><strong>Grand Total:</strong></td>
                      <td>
                        <strong>
                          {formatCurrency(
                            modalData.items.reduce((sum, item) => sum + item.price, 0)
                          )}
                        </strong>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </>
          ) : (
            <p>Loading data...</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default WishlistModal;
